import React, { useState, useRef, useEffect } from 'react';
import './expandable-component-style.css';

const ExpandableComponent = ({ children }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const contentRef = useRef(null);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    // useEffect(() => {
    //     setTimeout(() => {
    //         setIsExpanded(true)
    //     }, 1000);
    // }, [])

    useEffect(() => {
        if (contentRef.current) {
            if (isExpanded) {
                // Temporarily set maxHeight to none to calculate the full height of the content
                contentRef.current.style.maxHeight = 'none';
                const fullHeight = contentRef.current.scrollHeight;
                // Then set maxHeight to 0 before applying the actual height for transition
                contentRef.current.style.maxHeight = '0';
                setTimeout(() => {
                    contentRef.current.style.maxHeight = `${fullHeight}px`;
                }, 10); // Short delay
            } else {
                // Set maxHeight back to the current scrollHeight before collapsing
                contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight}px`;
                setTimeout(() => {
                    contentRef.current.style.maxHeight = '0';
                }, 10);
            }
        }
    }, [isExpanded]);



    return (
        <div className='transition-all ease-in-out'>
            <div className="inline-flex justify-center items-center text-base font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800 transition-all duration-150">
                <button type="button" className='px-5 py-3 flex items-center' onClick={toggleExpand}>
                    <div className='mx-2'>
                        {!isExpanded ? (
                            // Arrow pointing up when expanded
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75" />
                            </svg>
                        ) : (
                            // Arrow pointing down when collapsed
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75" />
                            </svg>
                        )}
                    </div>
                    {isExpanded ? 'הסתר' : 'הצג'}
                </button>
            </div>
            <div ref={contentRef} className={`mt-10 expandable-content ${isExpanded ? "expanded" : ""}`}>
                {children}
            </div>
        </div>
    );
};

export default ExpandableComponent;
